import * as React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import clsx from 'clsx';
import Sidebar from './Sidebar';
import webBgRight from '../images/web-bg-right.svg';
import { theme1 } from '../theme/globalStyle';
import { StepperContext } from '../contexts/stepperContext';
import Header from './Header';
import Footer from './Footer';

const Page1 = React.lazy(() => import('./pages/Page1'));
const Page2 = React.lazy(() => import('./pages/Page2'));
const Page3 = React.lazy(() => import('./pages/Page3'));
const Page4 = React.lazy(() => import('./pages/Page4'));
const Page5 = React.lazy(() => import('./pages/Page5'));
const Page6 = React.lazy(() => import('./pages/Page6'));

const renderCurrentPage = (currentPage) => {
  switch (true) {
    case currentPage === 0:
      return <Page1 />;
    case currentPage === 1:
      return <Page2 />;
    case currentPage === 2:
      return <Page3 />;
    case currentPage === 3:
      return <Page4 />;
    case currentPage === 4:
      return <Page5 />;
    case currentPage === 5:
      return <Page6 />;
    default:
      return null;
  }
};

const StyledPage = styled.div`
  font-family: 'Roboto', serif;
  height: calc(100% - 30px);
  min-height: calc(100% - 30px);
  -webkit-overflow-scrolling: touch;
  font-weight: 500;
  color: ${(props) => props.theme.primary};
  font-size: 16px;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  &.webBgRight {
    background-position: bottom 0 right 0;
    background-size: 35vw;
    background-repeat: no-repeat;
    background-image: url(${webBgRight});
  }
`;

const StyledSection = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
`;

const AnimatedContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
`;

const Stepper = function () {
  const { state } = React.useContext(StepperContext);
  const { currentPage, animationDirection } = state;
  return (
    <React.Suspense fallback={null}>
      <ThemeProvider theme={theme1}>
        <StyledPage
          className={clsx({
            webBgRight: currentPage > 1 && currentPage < 4,
          })}
        >
          <StyledSection>
            <Header currentPage={currentPage} />
            <AnimatedContainer
              className={clsx('animate__animated', {
                [`animate__${animationDirection}`]: animationDirection,
              })}
            >
              {renderCurrentPage(currentPage)}
            </AnimatedContainer>
          </StyledSection>
          {currentPage > 1 && currentPage < 5 && <Sidebar />}
        </StyledPage>
        <Footer />
      </ThemeProvider>
    </React.Suspense>
  );
};

export default Stepper;
